import App from "./App.svelte";
import data from "./data/index.js";

let app;
const localStorageKey = "mag-interactive--outlook-spin-off";

function init() {
  app = new App({
    target: document.querySelector("#server-rendered-html"),
    props: {
      data,
    },
    hydrate: true,
  });

  app.$on("update", () => {
	console.log("Update");
    let requestData = window.localStorage.getItem(localStorageKey);
    let documentHeight = document.querySelector("body").offsetHeight;
    if (requestData) {
      window.parent.postMessage(
        { height: documentHeight + 40, requestData: JSON.parse(requestData) },
        "*"
      );
    }
    console.log("messageOnUpdate", {
      height: documentHeight,
      requestData,
    });
  });
}

document.addEventListener("DOMContentLoaded", init);

export default app;
